<div
  class="standard-dropdown-item w-full"
  [class.align-items-start]="!singleLine"
  [class.align-items-center]="singleLine"
  [class.standard-dropdown-item--single-line]="singleLine"
  [class.standard-dropdown-item--grid]="!!item.description"
  [class.flex]="!item.description"
  [class.justify-content-between]="!item.description"
  [class.gap-3]="!item.description">
  <div
    class="standard-dropdown-item__body flex-1 min-w-0"
    [class.flex]="singleLine"
    [class.align-items-center]="singleLine"
    [class.gap-2]="singleLine">
    <p
      class="standard-dropdown-item__name"
      [class.font-bold]="item?.font === 'bold'"
      [class.font-light]="item?.font === 'thin'"
      [innerHTML]="item.name | highlightMatch: filterValue | safeHtml"></p>
    @if (item.extra?.length) {
      @if (singleLine) {
        <span class="standard-dropdown-item__extras">
          @for (extra of item.extra; track $index) {
            @if (extra?.content) {
              <span
                [class.frm-color-green]="extra?.color === 'emphasis'"
                [class.text-gray-500]="extra?.color === 'muted'"
                [class.text-red-500]="extra?.color === 'warning'"
                [class.font-bold]="extra?.font === 'bold'"
                [class.font-light]="extra?.font === 'thin'"
                [innerHTML]="extra?.content | highlightMatch: filterValue | safeHtml"></span>
            }
          }
        </span>
      } @else {
        @for (extra of item.extra; track $index) {
          <p
            class="mt-1"
            [class.frm-color-green]="extra?.color === 'emphasis'"
            [class.text-gray-500]="extra?.color === 'muted'"
            [class.text-red-500]="extra?.color === 'warning'"
            [class.font-bold]="extra?.font === 'bold'"
            [class.font-light]="extra?.font === 'thin'">
            <span [innerHTML]="extra?.content | highlightMatch: filterValue | safeHtml"></span>
          </p>
        }
      }
    }
  </div>

  @if (item.description) {
    <div
      class="standard-dropdown-item__description min-w-0"
      [class.standard-dropdown-item__description--span]="!item.status"
      [class.flex]="singleLine"
      [class.align-items-center]="singleLine"
      [class.gap-2]="singleLine">
      <div
        class="standard-dropdown-item__description-content"
        [class.frm-color-green]="item.description.color === 'emphasis'"
        [class.text-gray-500]="item.description.color === 'muted'"
        [class.text-red-500]="item.description.color === 'warning'"
        [class.font-bold]="item.description.font === 'bold'"
        [class.font-light]="item.description.font === 'thin'"
        [innerHTML]="item.description.content | highlightMatch: filterValue | safeHtml">
      </div>
      @if (item.description.extra?.length) {
        @if (singleLine) {
          <span class="standard-dropdown-item__extras">
            @for (extra of item.description.extra; track $index) {
              @if (extra?.content) {
                <span
                  [class.frm-color-green]="extra?.color === 'emphasis'"
                  [class.text-gray-500]="extra?.color === 'muted'"
                  [class.text-red-500]="extra?.color === 'warning'"
                  [class.font-bold]="extra?.font === 'bold'"
                  [class.font-light]="extra?.font === 'thin'"
                  [innerHTML]="extra?.content | highlightMatch: filterValue | safeHtml"></span>
              }
            }
          </span>
        } @else {
          @for (extra of item.description.extra; track $index) {
            <div
              class="mt-1"
              [class.frm-color-green]="extra?.color === 'emphasis'"
              [class.text-gray-500]="extra?.color === 'muted'"
              [class.text-red-500]="extra?.color === 'warning'"
              [class.font-bold]="extra?.font === 'bold'"
              [class.font-light]="extra?.font === 'thin'">
              <span [innerHTML]="extra?.content | highlightMatch: filterValue | safeHtml"></span>
            </div>
          }
        }
      }
    </div>
  }

  @if (item.status) {
    <div class="flex-shrink-0 white-space-nowrap">
      <crm-status-label
        [name]="item.status.name"
        [color]="item.status.color"></crm-status-label>
    </div>
  }
</div>
